<template>
  <label class="label" :for="forInput">
    <span v-if="text">{{ text }}<sup v-if="required"> *</sup></span> <span v-if="iconClass" :class="iconClass"></span>
     <slot />
  </label>
</template>

<script>
export default {
  props: {
    forInput: {
      required: false,
      type: String
    },
    text: {
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    iconClass: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.label {
  position: relative;
  color: #6a6b70;
  font-family: $ToyotaBook;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;

  span {
    position: relative;
    display: inline-block;
    margin-bottom: 7px;
  }

  sup {
    position: relative;
    color: #ff0022;
    font-family: $ToyotaBook;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
  }

  .search-icon {
    @include vertical-center;

    right: 14px;
    width: 16px;
    height: 18px;
    cursor: pointer;

    &::before {
      @include pseudo(100%, 100%, 'search-icon.svg');
    }
  }
}

@include media-min($desktop-width) {
  .label {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseLabel.vue